export default __webpack_public_path__ + "static/media/postman.c74cd48d.svg";